export default {"src":"/_next/static/media/heart_yellow.935e152a.svg","height":24,"width":26,"blurWidth":0,"blurHeight":0};